import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_51: FaireProductEntity = {
  token: "catalog_prod_prod-51",
  type: "product",
  name: "Wooden Serving Board - Live Edge",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 99.7,
  msrpDollars: 249.25,
  sku: "JA0051",
  caseSize: 12,
  material: "Ceramic",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 310,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_garden-outdoor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
